import React, { Component, Fragment } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, PaginationTotalStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport, faFileExcel } from '@fortawesome/free-solid-svg-icons';

const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
        &nbsp;Mostrando {from} a {to} de {size} resultados
    </span>
);

const { ExportCSVButton } = CSVExport;
class listaDatos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sizePerPage: 5,
        };
    }

    calculasizePerPageList = (cantidad) => {

        let lista = [];
        if ((cantidad == 0) || (cantidad == undefined)) {
            lista = [{
                text: '0', value: 5
            }, {
                text: 'Todo', value: cantidad
            }]
            return lista;
        }

        if (cantidad <= 15) {
            lista = [{
                text: '5', value: 5
            }, {
                text: '10', value: 10
            },
            {
                text: 'Todo', value: cantidad
            }]
            return lista;
        }

        if (cantidad <= 20) {
            lista = [{
                text: '5', value: 5
            }, {
                text: '10', value: 10
            }, {
                text: '15', value: 15
            },
            {
                text: 'Todo', value: cantidad
            }]
            return lista;
        }

        if (cantidad <= 50) {
            lista = [{
                text: '5', value: 5
            }, {
                text: '10', value: 10
            }, {
                text: '15', value: 15
            }, {
                text: '25', value: 25
            }, {
                text: '35', value: 35
            },
            {
                text: 'Todo', value: cantidad
            }]
            return lista;
        }
        if (cantidad > 50) {
            lista = [{
                text: '5', value: 5
            }, {
                text: '10', value: 10
            }, {
                text: '15', value: 15
            }, {
                text: '25', value: 25
            }, {
                text: '35', value: 35
            }, {
                text: '65', value: 65
            }, {
                text: '85', value: 85
            }, {
                text: '100', value: 100
            },
            {
                text: 'Todo', value: cantidad
            }]
            return lista;
        }
    }


    render() {
        const { id, datos, columnas, striped, hover, condensed, selectRow, onDoubleClick, clases, borrar, verLHOC, cellEdit, rowStyle, tagExtra, busquedasExp, nombreCSV } = this.props;
        const { SearchBar } = Search;
        const name = "btnExportar";
        const clase = "btn btn-sm pull-right flipInX animated";
        const leyenda = "";
        const iclase = "fa fa-download";
        const _sizePerPageList = this.calculasizePerPageList(datos.length);
        const borra = (borrar !== undefined) ? borrar : false;
        const ExtraTag = (tagExtra != undefined) ? tagExtra : (() => { return (<Fragment></Fragment>) })
        const _busquedasExp = { display: (busquedasExp == undefined) ? "unset" : "none" }
        let optPaginacion = {}

        const NombreCsv = nombreCSV ?? "DatosTabla";
        const csvExport = {
            fileName: `${NombreCsv}.csv`,
            separator: ',',
            ignoreHeader: false,
            noAutoBOM: false
        };

        const pageButtonRenderer = ({
            page,
            active,
            disable,
            title,
            onPageChange
        }) => {
            const handleClick = (e) => {
                e.preventDefault();
                onPageChange(page);
            };
            const activeStyle = {};
            if (active) {
                activeStyle.backgroundColor = '#d73220';
                activeStyle.color = 'white';
            } else {
                activeStyle.backgroundColor = 'white';
                activeStyle.color = '#d73220';
            }
            if (typeof page === 'string') {
                activeStyle.backgroundColor = 'white';
                activeStyle.color = '#d73220';
            }
            return (
                <li className="page-item">
                    <a href="#" onClick={handleClick} style={activeStyle}>{page}</a>
                </li>
            );
        };

        optPaginacion = {
            //custom: true,
            paginationSize: this.state.sizePerPage,
            alwaysShowAllBtns: true,
            withFirstAndLast: true,
            hideSizePerPage: false,
            hidePageListOnlyOnePage: true,
            firstPageText: '<<',
            prePageText: '<',
            nextPageText: '>',
            lastPageText: '>> ',
            nextPageTitle: 'Siguiente Página',
            prePageTitle: 'Página Anterior',
            firstPageTitle: 'Primera Página',
            lastPageTitle: 'Última Página',
            showTotal: true,
            paginationTotalRenderer: customTotal,
            sizePerPageList: _sizePerPageList,
            dataSize: datos.length,
            pageStartIndex: 1,
            pageButtonRenderer
        };

        if (borra)
            optPaginacion.page = 1;

        const rowEvents = {
            onDoubleClick: (e, row, rowIndex) => {
                (onDoubleClick == null) ? () => { } : onDoubleClick(e, row, rowIndex);
            }
        };

        const NoDatos = 'No hay datos que mostrar';

        const renderSizePerPageDropDown = props => {

            return (
                <div className='btn-group'>
                    <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown">
                        {props.sizePerPage} <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu" role="menu">
                        {
                            props.sizePerPageList.map((n, idx) => {
                                return (
                                    <li key={idx}><a class="dropdown-item" onClick={() => {
                                        let pPage = props.page;

                                        if (Math.ceil(datos.length / n.value) < props.page) {
                                            pPage = 1;
                                        }

                                        props.onSizePerPageChange(n.value, pPage)
                                    }}>{n.text}</a></li>
                                );
                            })
                        }
                    </ul>
                </div>
            );
        }

        return (
            <Fragment>
                <ToolkitProvider
                    keyField={id}
                    data={datos}
                    columns={columnas}
                    search={ {searchFormatted: true} }
                    exportCSV={csvExport}
                >
                    {
                        props => (
                            <div>
                                <div className='row' style={_busquedasExp}>

                                    {/*   <div className={"col-md-8"} >
                                        <ExportCSVButton {...props.csvProps} className={clase}  >
                                            <i className={iclase} ></i>
                                        </ExportCSVButton>
                                    </div>
                                    <div className={"col-xs-4 col-sm-4 col-md-4 col-lg-4"} >
                                        <SearchBar {...props.searchProps} placeholder="Buscar" />
                        </div>*/}
                                    <div className={"col-xs-12 col-sm-12 col-md-12 col-lg-12"} style={{ margin: "15px 0" }}>

                                        <div style={{ float: "left" }}>
                                            <div class="tooltip2"><span class="tooltiptext2">Exportar</span>
                                                <ExportCSVButton {...props.csvProps} className={clase}  >
                                                    <i className={iclase} ></i>
                                                </ExportCSVButton>
                                            </div>
                                        </div>
                                        <div style={{ float: "right" }}>
                                            <SearchBar {...props.searchProps} placeholder="Buscar" />
                                        </div>

                                    </div>

                                </div>

                                <PaginationProvider
                                    pagination={paginationFactory(optPaginacion)}
                                >
                                    {
                                        ({
                                            paginationProps,
                                            paginationTableProps
                                        }) => (
                                            <Fragment>
                                                <div className={"col-xs-12 col-sm-12 col-md-12 col-lg-12"} >
                                                    <div className='table-responsive'>
                                                        <BootstrapTable
                                                            {...props.baseProps}
                                                            {...paginationTableProps}
                                                            striped={striped}
                                                            hover={hover}
                                                            condensed={condensed}
                                                            selectRow={selectRow}
                                                            rowEvents={rowEvents}
                                                            className={clases}
                                                            noDataIndication={NoDatos}
                                                            cellEdit={cellEditFactory(cellEdit)}
                                                            rowStyle={rowStyle}
                                                        />
                                                        {ExtraTag}
                                                    </div>
                                                </div>
                                                <div>

                                                   {/* {renderSizePerPageDropDown({ ...paginationProps })}

                                                    <PaginationTotalStandalone
                                                        {...paginationProps}
                                                    />

                                                    <PaginationListStandalone
                                                        {...paginationProps}
                                        />*/}
                                                </div>
                                            </Fragment>
                                        )
                                    }
                                </PaginationProvider>

                            </div>

                        )
                    }

                </ToolkitProvider>
                <hr></hr>
            </Fragment>
        )

    }

};
export default listaDatos;


